import {Fragment, PureComponent} from 'react'
import PropTypes from 'prop-types'
import {Badge} from 'reactstrap'

import Date from '../../components/Moment/Date.jsx'
import {POSITIONING_STATUS} from "../../constants.js"
import {isUserFreelance} from "../../services/userService.js"
import CardRow from "../Styled/Card/CardRow.jsx"

import "./Positionnings.scss"

export default class Positionings extends PureComponent {
  static propTypes = {
    positionings: PropTypes.array.isRequired
  }

  getStatusBadgeColor = (status) => {
    switch (status) {
    case POSITIONING_STATUS.WON:
      return 'success'
    case POSITIONING_STATUS.LOST:
      return 'danger'
    default:
      return 'info'
    }
  }

  getStatusBadgeLabel = (status) => {
    switch (status) {
    case POSITIONING_STATUS.WON:
      return 'Gagné'
    case POSITIONING_STATUS.LOST:
      return 'Perdu'
    default:
      return 'En cours'
    }
  }

  render() {
    const {user, positionings, isAdmin} = this.props

    if (positionings.length === 0) {
      if(isUserFreelance(user)) {
        return <p className="text-center">Vous n'avez été positionné sur aucune mission pour le moment.</p>
      }
      return <p className="text-center m-0">Aucun positionnement</p>
    }

    return (
      <div className="freelance-positioning">
        {/* Header for admin */}
        {isAdmin && (
          <CardRow className="positioning-row positioning-row-header">
            <div className="positioning-row-col positioning-deal-id">
              Deal ID
            </div>
            <div className="positioning-row-col positioning-title">
              Titre de la mission
            </div>
            <div className="positioning-row-col positioning-company">
              Entreprise
            </div>
            <div className="positioning-row-col positioning-price">
              Prix
            </div>
            <div className="positioning-row-col positioning-stage-label">
              Étape Pipedrive
            </div>
            <div className="positioning-row-col positioning-positioned-at">
              Positionné le
            </div>
            <div className="positioning-row-col positioning-status">
              Statut
            </div>
          </CardRow>
        )}

        {positionings.map((positioning, index) => {
          return (
            <CardRow className="positioning-row" style={{display: 'flex'}} key={`positioning-row-${index}`}>
              {isAdmin && (
                <div className="positioning-row-col positioning-deal-id">
                  {positioning.deal_id}
                </div>
              )}
              <div className="positioning-row-col positioning-title" >{positioning.title}</div>
              {isAdmin && (
                <Fragment>
                  <div className="positioning-row-col positioning-company">
                    {positioning.company}
                  </div>
                  <div className="positioning-row-col positioning-price">
                    {positioning.price}
                  </div>
                  <div className="positioning-row-col positioning-stage-label">
                    {positioning.stage_label}
                  </div>
                </Fragment>
              )}
              <div className="positioning-row-col positioning-positioned-at">
                {<Date format="dd/MM/yyyy" date={positioning.positioned_at}/>}
              </div>
              <div className="positioning-row-col positioning-status">
                <Badge color={this.getStatusBadgeColor(positioning.status)} className="mx-1">
                  {this.getStatusBadgeLabel(positioning.status)}
                </Badge>
              </div>
            </CardRow>
          )
        })}
      </div>
    )
  }
}
